import { render, staticRenderFns } from "./SolicitudInformacionCrear.vue?vue&type=template&id=0ba8d5d3&scoped=true&lang=pug&"
import script from "./SolicitudInformacionCrear.vue?vue&type=script&lang=js&"
export * from "./SolicitudInformacionCrear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba8d5d3",
  null
  
)

export default component.exports